import React from "react";
import { Navigate } from "react-router-dom";

import async from "@/components/Async";

// All pages that rely on 3rd party components (other than MUI) are
// loaded asynchronously, to keep the initial JS bundle to a minimum size

// Layouts
import AuthLayout from "@/layouts/Auth";
import ErrorLayout from "@/layouts/Error";
import DashboardLayout from "@/layouts/Dashboard";

// Guards
import AuthGuard from "@/components/guards/AuthGuard";

// Auth components
import SignIn from "@/pages/auth/SignIn";
import SignUp from "@/pages/auth/SignUp";
import ResetPassword from "@/pages/auth/ResetPassword";
import Page404 from "@/pages/auth/Page404";

// Components

// Table components

// Landing

// Protected routes
import ProtectedPage from "@/pages/protected/ProtectedPage";
import SetPassword from "./pages/auth/SetPassword";
import Academics from "./pages/protected/Academics";
import PersonalInformation from "./pages/protected/PersonalInformation";
import Schools from "./pages/protected/Schools";
import Scores from "./pages/protected/Scores";
import InitialQuestionnaire from "./pages/protected/InitialQuestionnaire";
import ExtracurricularActivities from "./pages/protected/ExtracurricularActivities";
import Awards from "./pages/protected/Awards";


// Icon components
// const Profile = async(() => import("@/pages/pages/Profile"));

// Table components

// Chart components

// Maps components

const routes = [
  {
    path: "auth",
    element: <AuthLayout />,
    children: [
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
      {
        path: "reset-password",
        element: <ResetPassword />,
      },
      {
        path: "set-password",
        element: <SetPassword />,
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={5} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Scores />,
      },
    ],
  },
  {
    path: "/school-results",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={5} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Scores />,
      },
    ],
  },
  {
    path: "/profile",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={0} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <PersonalInformation />,
      },
    ],
  },
  {
    path: "/initial-questionnaire",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={1} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <InitialQuestionnaire />,
      },
    ],
  },
  {
    path: "/academics",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={2} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Academics />,
      },
    ],
  },
  {
    path: "/extracurricular-activities",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={3} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <ExtracurricularActivities />,
      },
    ],
  },
  {
    path: "/awards",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={4} />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Awards />,
      },
    ],
  },
  {
    path: "/schools",
    element: (
      <AuthGuard>
        <DashboardLayout currentStep={-1}  />
      </AuthGuard>
    ),
    children: [
      {
        path: "",
        element: <Schools />,
      },
    ],
  },
  {
    path: "dashboard",
    element: <DashboardLayout />,
    children: [
      {
        path: "",
        element: <div>Dashboard Home</div>,
      },
    ],
  },
  {
    path: "*",
    element: <ErrorLayout />,
    children: [
      {
        path: "*",
        element: <Page404 />,
      },
    ],
  },
];

export default routes;
